import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { setSession } from '../admin/auth';
import { authApi } from '../services/authApi';

const Connexion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '', remember: true });
  const [status, setStatus] = useState({ loading: false, error: null });
  const [showPwd, setShowPwd] = useState(false);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null });

    try {
      const { token, user } = await authApi.login(form.email, form.password);
      setSession({ token, user });

      const from = location.state?.from;
      if (from && from.startsWith('/admin')) navigate(from, { replace: true });
      else if (user.role === 'admin') navigate('/admin/dashboard', { replace: true });
      else navigate('/', { replace: true });
    } catch (err) {
      setStatus({ loading: false, error: err.message || 'Identifiants invalides.' });
    }
  };

  return (
    <main className="auth-page">
      <aside className="auth-side">
        <div className="auth-side-bg" />
        <div className="auth-side-grain" />
        <div className="auth-side-inner">
          <Link to="/" className="auth-brand">
            <span className="brand-mark"></span>
            <span>Cambérène<small>SN · 221</small></span>
          </Link>
          <div>
            <span className="eyebrow" style={{ color: 'rgba(250,246,238,.7)' }}>Espace membre · 221</span>
            <h1 className="auth-side-h" style={{ marginTop: 14 }}>
              Le village,<br /><span className="ital">connecté à vous.</span>
            </h1>
            <p className="auth-side-p">
              Retrouvez vos contributions, vos commerces référencés, vos photos soumises
              et l'actualité de la communauté Layène.
            </p>
          </div>
          <div className="auth-side-foot">
            <span>Cambérène · 14.78°N</span>
            <span>· Layène · 1884</span>
          </div>
        </div>
      </aside>

      <section className="auth-form-side">
        <div className="auth-form-wrap">
          <div className="auth-head">
            <span className="eyebrow">Connexion</span>
            <h2 className="auth-h">Bon retour<br /><span className="ital">parmi nous.</span></h2>
            <p className="auth-sub">Connectez-vous pour gérer vos contributions et accéder aux espaces réservés.</p>
          </div>

          <form className="auth-form" onSubmit={onSubmit} noValidate>
            <label className="auth-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                autoComplete="email"
                placeholder="votre@adresse.email"
                value={form.email}
                onChange={onChange}
                required
              />
            </label>

            <label className="auth-field">
              <span className="auth-field-row">
                Mot de passe
                <Link to="/mot-de-passe-oublie" className="auth-link-small">Oublié ?</Link>
              </span>
              <div className="auth-pwd">
                <input
                  type={showPwd ? 'text' : 'password'}
                  name="password"
                  autoComplete="current-password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={onChange}
                  minLength={6}
                  required
                />
                <button
                  type="button"
                  className="auth-pwd-toggle"
                  onClick={() => setShowPwd((s) => !s)}
                  aria-label={showPwd ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPwd ? 'Masquer' : 'Afficher'}
                </button>
              </div>
            </label>

            <label className="auth-check">
              <input
                type="checkbox"
                name="remember"
                checked={form.remember}
                onChange={onChange}
              />
              <span>Rester connecté sur cet appareil</span>
            </label>

            {status.error && <div className="auth-error">{status.error}</div>}

            <button
              type="submit"
              className="btn btn-primary auth-submit"
              disabled={status.loading}
            >
              <span>{status.loading ? 'Connexion…' : 'Se connecter'}</span>
              {!status.loading && <span className="arrow">→</span>}
            </button>

            <div className="auth-sep"><span>ou</span></div>

            <button type="button" className="btn btn-outline auth-oauth" disabled>
              <span>Continuer avec Google</span>
            </button>
          </form>

          <p className="auth-switch">
            Pas encore de compte ?{' '}
            <Link to="/inscription" className="auth-link">Rejoindre la communauté →</Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default Connexion;
